import { RootState } from 'redux/types'

import { OrderTotals } from '../types'

const getOrderTotals = (state: RootState): OrderTotals => state.orderTotals

export default { getOrderTotals }
